import { Text } from '@wix/design-system';
import React from 'react';
import { BiCtaNames, BiModalTypes } from '../../bi/types';
import { getEditorCapabilitiesForHost } from '../../utils/editor-host-to-editor-type';
import { buildStudioDialogProps } from './build-studio-dialog-props';
export const getScanAllSiteVerificationModalProps = (t, editorHost) => {
  const {
    usesClassicModalChrome
  } = getEditorCapabilitiesForHost(editorHost);
  return {
    content: usesClassicModalChrome ? t('accessibility-wizard.scan-all-site-verification-modal.content') : /*#__PURE__*/React.createElement(Text, null, t('accessibility-wizard.scan-all-site-verification-modal.content')),
    primaryButtonText: t('accessibility-wizard.scan-all-site-verification-modal.primary-button'),
    secondaryButtonText: t('accessibility-wizard.scan-all-site-verification-modal.secondary-button'),
    skin: 'standard',
    title: t('accessibility-wizard.scan-all-site-verification-modal.title')
  };
};
export const showScanAllSiteVerificationModal = async _ref => {
  let {
    biLogger,
    handleApply,
    a11yWizardAdapter,
    t,
    handleDiscard,
    editorHost
  } = _ref;
  const {
    usesClassicModalChrome
  } = getEditorCapabilitiesForHost(editorHost);
  const modalProps = {
    ...getScanAllSiteVerificationModalProps(t, editorHost),
    primaryButtonOnClick: () => {
      biLogger.modalCtaClick({
        ctaName: BiCtaNames.ScanAllSite,
        modalType: BiModalTypes.ScanAllSiteVerification
      });
      handleApply();
    },
    secondaryButtonOnClick: () => {
      biLogger.modalCtaClick({
        ctaName: BiCtaNames.ScanOnlyPage,
        modalType: BiModalTypes.ScanAllSiteVerification
      });
      handleDiscard();
    }
  };
  biLogger.modalView({
    modalType: BiModalTypes.ScanAllSiteVerification
  });
  if (usesClassicModalChrome) {
    await a11yWizardAdapter.showDialog({
      ...modalProps,
      theme: modalProps.skin
    });
    return;
  }
  await a11yWizardAdapter.showDialog(...buildStudioDialogProps(modalProps));
};
//# sourceMappingURL=show-scan-all-site-verification-modal.js.map